import React from 'react';

function AddStoryPrompt({ onClick }) {
  return (
    <div className="add-story-prompt-prominent" onClick={onClick}>
      <div className="prompt-content">
        <div className="prompt-icon">✏️</div>
        <div className="prompt-text-wrapper">
          <h4>Add the story behind these photos</h4>
          <p>Help your family understand what made this moment special</p>
        </div>
      </div>
      <button className="prompt-button">
        Write
      </button>
    </div>
  );
}

export default AddStoryPrompt;
